import { useSelector } from 'react-redux';
import { aiFeaturesEnabledSelector } from '../../../../../redux/modules/organizationGroup/selectors';
import { useIsFeatureEnabled } from '../../../../feature-enablement/featureEnablement';

/**
 * One gate over the whole agentic lookup editor. The agent needs the chat drawer (`mr-fabry`) and
 * the V2 backend (i.e. not `mr-fabry-legacy`), so all three flags are read — unconditionally, since
 * an `a() && b()` one-liner would short-circuit and break the rules of hooks.
 */
export const useIsLookupAgentEnabled = () => {
  const isFabryEnabled = useIsFeatureEnabled('mr-fabry');
  const isLegacyBackendEnabled = useIsFeatureEnabled('mr-fabry-legacy');
  const isLookupAgentEnabled = useIsFeatureEnabled('pat-645-lookup-agent');
  const aiFeaturesEnabled = useSelector(aiFeaturesEnabledSelector);

  return (
    isFabryEnabled &&
    !isLegacyBackendEnabled &&
    isLookupAgentEnabled &&
    aiFeaturesEnabled
  );
};
